var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.type === 0
        ? _c("yxt-autocomplete", {
            staticClass: "width-percent-100-i",
            attrs: {
              disabled: _vm.disabled,
              maxlength: 36,
              "hide-loading": false,
              debounce: 800,
              "fetch-suggestions": _vm.search,
              placeholder: _vm.$t(
                "pc_kng_custom_lbl_please_fill_in" /** 请填写 */
              ),
            },
            on: { select: _vm.select },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("yxtbiz-user-name", {
                        attrs: { name: scope.item.value },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              2496056776
            ),
            model: {
              value: _vm._value,
              callback: function ($$v) {
                _vm._value = $$v
              },
              expression: "_value",
            },
          })
        : _c("yxt-select", {
            staticClass: "width-percent-100-i",
            attrs: {
              multiple: "",
              placeholder: _vm.$t("pc_select_placeholder" /** 请选择 */),
              "icon-name": "more",
              "hidden-option": "",
              "collapse-tags": "",
              "value-key": "id",
              "prop-label": "name",
              size: "small",
              disabled: _vm.disabled,
            },
            on: { "remove-tag": _vm.remove },
            nativeOn: {
              click: function ($event) {
                return _vm.open.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "tag",
                fn: function (ref) {
                  var data = ref.data
                  return [_c("span", [_vm._v(_vm._s(data.currentLabel))])]
                },
              },
            ]),
            model: {
              value: _vm.multiValue,
              callback: function ($$v) {
                _vm.multiValue = $$v
              },
              expression: "multiValue",
            },
          }),
      _c(
        "yxt-drawer",
        {
          attrs: { visible: _vm.visible, size: "960px" },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _vm.type === 2
            ? _c("yxtbiz-teacher-selector", {
                attrs: {
                  functionCode: _vm.functionCode,
                  dataPermissionCode: _vm.dataPermissionCode,
                },
                model: {
                  value: _vm.user,
                  callback: function ($$v) {
                    _vm.user = $$v
                  },
                  expression: "user",
                },
              })
            : _c("yxtbiz-range-selector", {
                attrs: {
                  multiple: false,
                  tabs: [{ type: "persons", isShowDeptment: true }],
                  functionCode: _vm.functionCode,
                  dataPermissionCode: "CourseOwner_extent",
                },
                model: {
                  value: _vm.user,
                  callback: function ($$v) {
                    _vm.user = $$v
                  },
                  expression: "user",
                },
              }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "yxt-button",
                { attrs: { plain: "" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel" /** 取消 */)))]
              ),
              _c(
                "yxt-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure" /** 确定 */)))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }